import React, { useState } from 'react';
import './page.css';

const PaginationComponent = ({
    itemsPerPage,
    handleItemsPerPageChange,
    handlePageChange,
    currentPage,
    isNextDisabled,
    data
}) => {
    const [inputPage, setInputPage] = useState(currentPage); // Local state for input page

    // Handle user input for page number change
    const handleInputChange = (e) => {
        setInputPage(e.target.value);
    };

    // Handle "Go" button click to navigate to the inputted page
    const handleGoToPage = () => {
        const pageNumber = parseInt(inputPage, 10);
        if (pageNumber > 0 && pageNumber !== currentPage) {
            handlePageChange(pageNumber); // Navigate to inputted page
        }
    };

    return (
        <div className="pagination-container">

            {/* <div className="row-page">Total Rows {data?.length}</div> */}
            <div className="row-page"></div>


            <div className="pagination-body">
                <div className="items-per-page-container">
                    <label htmlFor="itemsPerPage">Items per page: </label>
                    <select
                        id="itemsPerPage"
                        value={itemsPerPage}
                        onChange={handleItemsPerPageChange}
                        className="border-select"
                    >
                        <option value={10}>10 / page</option>
                        <option value={20}>20 / page</option>
                        <option value={50}>50 / page</option>
                        <option value={100}>100 / page</option>
                        <option value={200}>200 / page</option>
                        <option value={500}>500 / page</option>

                    </select>
                </div>
                <div className="pagination-container-btn">
                    <button
                        className="prev"
                        style={{
                            background: currentPage === 1 ? 'grey' : '',
                            cursor: currentPage === 1 ? 'default' : ''
                        }}
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Prev
                    </button>
                    <span className='input-span' style={{ border: "none" }}>{currentPage}</span>
                    <button
                        className="prev"
                        style={{
                            background: isNextDisabled ? 'grey' : '',
                            cursor: isNextDisabled ? 'default' : ''
                        }}
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={isNextDisabled}
                    >
                        Next
                    </button>
                </div>
                <div className="go-page">
                    <input
                        className="input-span"
                        value={inputPage}
                        onChange={handleInputChange} // Update input page value
                    />
                    <button className="prev" onClick={handleGoToPage}>
                        Go to
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaginationComponent;
